import { useDocStore } from 'stores/DocStore'
import { AlmostDoneMessage } from './AlmostDoneMessage'
import { CompleteMessage } from './CompleteMessage'

const BottomMessage = () => {
  const docStore = useDocStore()
  const collabItems = docStore.cleanupModeStore.collabItemsForCleanup

  return collabItems.length > 0 ? <AlmostDoneMessage /> : <CompleteMessage />
}

export { BottomMessage }
